<div class="d-flex align-items-center justify-content-between">
  <div class="branding col-12" style="padding:0">
    <app-branding></app-branding>
  </div>

  @if(showToggle) {
  <a href="javascript:void(0)"
     (click)="toggleMobileNav.emit()"
     class="d-flex justify-content-center icon-40 align-items-center f-s-14">
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </a>
  }
</div>

<!-- 🔍 Search field -->
<mat-form-field appearance="outline" class="w-100 m-t-10">
  <mat-label>{{ 'Shared.Search' | translate }}</mat-label>

  <input matInput
         [(ngModel)]="searchText"
         (ngModelChange)="onSearchChange($event)"
         placeholder="{{ 'Shared.Filter' | translate }}" />

  @if (searchText) {
    <button matSuffix mat-icon-button (click)="searchText = ''; onSearchChange('')">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>

<!-- 📋 Display filtered results -->
  <mat-nav-list class="sidebar-list">

    @if (filteredItems.length === 0 && searchText) {
      <div class="p-16 text-center">
        <mat-icon class="icon-48 opacity-50">search_off</mat-icon>
        <p class="m-t-8 f-s-14 opacity-70">
          {{ 'Shared.NoMatchFound' | translate }}
        </p>
      </div>
    }
    @for (item of filteredItems; track item.id) {
      <app-nav-item [item]="item"
                    [depth]="0"
                    (notify)="toggleMobileNav.emit()"></app-nav-item>
    }
  </mat-nav-list>
